import { combineReducers } from 'redux';
import App from './app/reducer';
import Auth from './auth/reducer';
import ThemeSwitcher from './themeSwitcher/reducer';

export default combineReducers({
  Auth,
  App,
  ThemeSwitcher
});
